// F12 · MainLayout — wraps public routes with HeaderV4 + FooterV4.
//
// Rollback: `REACT_APP_HEADER_V4_ENABLED=false` falls back to the
// pre-existing <Header /> (authenticated-only; renders null for guests)
// + legacy <Footer />. This gives operators instant rollback without a
// rebuild — just toggle the env and restart.
//
// Design: full-height column so the footer sticks to the bottom on
// short placeholder pages.

import React from "react";
import HeaderV4 from "@/components/header-v4/HeaderV4";
import FooterV4 from "@/components/footer-v4/FooterV4";
// @deprecated Replaced by HeaderV4 (F12). Kept for rollback via
//             REACT_APP_HEADER_V4_ENABLED=false.
import HeaderLegacy from "@/components/Header";
import FooterLegacy from "@/components/Footer";

const V4_ENABLED = (process.env.REACT_APP_HEADER_V4_ENABLED ?? "true") !== "false";

export default function MainLayout({ children }) {
    return (
        <div
            data-testid="main-layout"
            data-v4-enabled={V4_ENABLED ? "true" : "false"}
            className="min-h-screen flex flex-col"
            style={{ backgroundColor: "#0A0A0A", color: "#FFFFFF" }}
        >
            {V4_ENABLED ? <HeaderV4 /> : <HeaderLegacy />}
            <div className="flex-1 flex flex-col">{children}</div>
            {V4_ENABLED ? <FooterV4 /> : <FooterLegacy />}
        </div>
    );
}
